import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const TransportNavigator = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <>
            <Header />

          
            <div style={{ height: "100px" }} />

            <Container>
                <Row className="justify-content-center mb-4">
                   
                    <Col md={4} className="mb-4">
                        <Card
                            className="shadow-lg border-0 text-center bg-light"
                            onClick={() => handleNavigation("/transport")}
                            style={{ cursor: "pointer", transition: "transform 0.3s ease" }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <Card.Body>
                                <h4 className="text-primary">Attendance</h4>
                                <p className="text-muted">View and manage attendance records.</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4">
                        <Card
                            className="shadow-lg border-0 text-center bg-light"
                            onClick={() => handleNavigation("/transportdetails")}
                            style={{ cursor: "pointer", transition: "transform 0.3s ease" }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <Card.Body>
                                <h4 className="text-primary">Attendance Filter</h4>
                                <p className="text-muted">Access detailed transport information.</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4">
                        <Card
                            className="shadow-lg border-0 text-center bg-light"
                            onClick={() => handleNavigation("/montylyInformation")}
                            style={{ cursor: "pointer", transition: "transform 0.3s ease" }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <Card.Body>
                                <h4 className="text-primary">Monthly Attendance</h4>
                                <p className="text-muted">Check monthly attendance summaries.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );

};

export default TransportNavigator;